module.exports = __webpack_public_path__ + "static/media/22-en.29362ff4.svg";